module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//24.jpg?96bd363ef6435e901a5d69b8d2da9a0c";